export default "__VITE_ASSET__BfaDMKWP__"